import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../services/cache/storage.service';

export const authGuard: CanActivateFn = (
  _: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> => {
  const auth = inject(AuthService);
  const localStorage = inject(LocalStorageService);

  return auth.getUserState().pipe(
    map(isAuthenticated => {
      if (isAuthenticated) {
        return true;
      } else {
        localStorage.set('redirectTo', state.url);
        auth.redirectLogin();
        return false;
      }
    }),
  );
};
